import Vue from 'vue'
import EventBus from '../core/utils/eventBus'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  action: {
    text: 'Close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    },
  },
  position: 'top-center',
  duration: 3000,
  theme: 'outline',
})

EventBus.on('successFlashMessage', function (payload) {
  Vue.toasted.success(payload)
})

EventBus.on('errorFlashMessage', function (payload) {
  Vue.toasted.error(payload || 'Oops.. Something Went Wrong..')
})
